// Navegacao para o layout DP (Departamento Pessoal)
function acessar_novo_cliente() {
  window.location.replace('/dp')
}

window.acessar_novo_cliente = acessar_novo_cliente
